import {
  CloudRoutingSettingsPageQuery_service_variant_router,
  GraphVariantRouterFragment,
  RouterEndpoints,
} from 'src/lib/graphqlTypes/types';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';

type MaybeRouter =
  | CloudRoutingSettingsPageQuery_service_variant_router
  | GraphVariantRouterFragment['router']
  | undefined
  | null;

const maybeFirstElement = (arr: string[] | undefined | null) =>
  isMinLengthArray(1, arr) ? arr[0] : undefined;

const firstCustomDomain = ({ endpoints }: { endpoints: RouterEndpoints }) =>
  maybeFirstElement(endpoints.custom);

export const pluckCloudRouterEndpoint = (
  router: MaybeRouter,
): string | undefined => {
  if (!router || router.status === 'DELETED' || !router.endpoints) {
    return;
  }

  return firstCustomDomain(router) || router.endpoints.default || undefined;
};
